import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

type CheckboxContainerProps = {
  isActive: boolean;
};

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin: 10px 0;
`;

export const CheckboxLabel = styled(Text14)`
  cursor: pointer;
`;
